module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.canAdd) ? _c('div', [(_vm.productMainView == 'cartactions') ? _c('button', {
    staticClass: "cta-btn cta-btn-sm",
    staticStyle: {
      "width": "50vw"
    },
    on: {
      "click": _vm.addToCart
    }
  }, [_vm._v(" " + _vm._s(_vm.productMain.product_cta_name || ' Buy Now'))]) : _c('button', {
    staticClass: "cta-btn",
    staticStyle: {
      "width": "50vw"
    },
    on: {
      "click": _vm.addToCart
    }
  }, [_vm._v(" " + _vm._s(_vm.productMain.product_cta_name || ' Buy Now'))])]) : _c('div', [_c('button', {
    staticClass: "cta-btn",
    staticStyle: {
      "width": "50vw",
      "text-align": "left",
      "padding-left": "5px",
      "font-size": "14px"
    },
    on: {
      "click": function($event) {
        _vm.redir(_vm.productMain.product_business_ownername)
      }
    }
  }, [_vm._v(" Continue Shopping")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f2668b7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/ProductCTAActions.vue
// module id = 426
// module chunks = 0